import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { SortOrder } from '@/components/ui/table'
import { GuestModel, VisitorStatus } from '@/models'

export type GetGuestsRequest = {
  buildingId?: number
  search?: string
  filter?: string
  skip?: number
  limit?: number
  clientId?: number[]
  sort?: string
  direction?: SortOrder
}

export type GetGuestsResponse = {
  data: GuestModel[]
  total: number
  skip: number
  limit: number
  countByStatus: Record<VisitorStatus, number>
}

export const GET_GUESTS_BASE_QUERY_KEY = 'useGetGuests'

export const getGuestsQueryKey = (data: GetGuestsRequest) => [GET_GUESTS_BASE_QUERY_KEY, data]

export const getGuests = async (data: GetGuestsRequest): Promise<GetGuestsResponse> => {
  const response = await authAPI.get('/client-guest-with-count', { params: data })
  return response.data
}

export const useGetGuests = (data: GetGuestsRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: () => getGuests(data),
    queryKey: getGuestsQueryKey(data),
  })
}
